import React, { ChangeEvent, ReactElement, useState } from 'react';
import { TextField } from '@mui/material';
import { Autocomplete } from '@mui/material';
import { filterSelectedSites, getSiteOptionString, isSiteSelected } from './AutocompleteHelper';
import { SiteDto } from '../../../api/ClientApi';

type SiteAutocompleteProps = {
    isRequired?: boolean;
    title?: string;
    sites: SiteDto[];
    selectedSiteId?: number;
    selectSite(siteId?: number): void;
};

export default function SiteAutocomplete(props: SiteAutocompleteProps): ReactElement {
    const { isRequired, title, sites, selectedSiteId, selectSite } = props;

    const [siteFilter, setSiteFilter] = useState<string>('');

    const handleSiteIdSelect = (siteId?: number) => {
        selectSite(siteId);
    };

    const handleSiteSelect = (event: ChangeEvent<unknown>, value: string | null): void => {
        if (value !== null) {
            const searchedSite = sites?.find((a) => {
                return isSiteSelected(a, value);
            });

            if (!!searchedSite && !!searchedSite.id && searchedSite?.id >= 0) {
                handleSiteIdSelect(searchedSite.id);
            }
        } else {
            handleSiteIdSelect(undefined);
        }
    };

    const handleSiteFilterChange = (event: ChangeEvent<{ value: unknown }>): void => {
        const searchToken: string = (event.target.value as string) ?? '';

        setSiteFilter(searchToken);
    };

    return (
        <Autocomplete
            freeSolo
            options={sites.map((option) => getSiteOptionString(option))}
            filterOptions={(x) => {
                return filterSelectedSites(x, siteFilter);
            }}
            value={selectedSiteId ? getSiteOptionString(sites.find((a) => a.id === selectedSiteId)) : null}
            onChange={handleSiteSelect}
            renderInput={(params) => (
                <TextField
                    {...params}
                    required={isRequired}
                    error={isRequired && (!selectedSiteId || selectedSiteId === 0)}
                    fullWidth
                    label={title ?? 'Skladište'}
                    variant="outlined"
                    style={{ backgroundColor: '#f7f7f7', borderRadius: 5 }}
                    onChange={handleSiteFilterChange}
                />
            )}
        />
    );
}
